import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Skeleton — loading placeholders (MA-07)
 */
import { forwardRef } from 'react';
import clsx from 'clsx';
export const Skeleton = forwardRef(({ shape = 'rectangular', lines = 1, className, style, ...rest }, ref) => {
    const pulse = 'animate-pulse rounded-md bg-neutral-200';
    if (shape === 'text' && lines > 1) {
        return (_jsx("div", { ref: ref, className: clsx('flex w-full flex-col gap-2', className), ...rest, children: Array.from({ length: lines }, (_, i) => (_jsx("div", { className: clsx(pulse, 'h-4 w-full', i === lines - 1 && 'w-4/5') }, `sk-line-${i}`))) }));
    }
    const shapeClass = shape === 'circular'
        ? 'aspect-square rounded-full'
        : shape === 'text'
            ? 'h-4 w-full rounded-md'
            : 'h-24 w-full rounded-lg';
    return (_jsx("div", { ref: ref, className: clsx(pulse, shapeClass, className), style: style, ...rest }));
});
Skeleton.displayName = 'Skeleton';
//# sourceMappingURL=Skeleton.js.map